import store from '@/store'

export default [
  {
    path: '/stock-count-entries',
    name: 'stock-count-entry',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-count-entry/index.vue')
  },
  {
    path: '/stock-count-entries/create',
    name: 'stock-count-entry-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-count-entry/create.vue')
  },
  {
    path: '/stock-count-entries/:id',
    name: 'stock-count-entry-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-count-entry/edit.vue'),
  }
]
